function snakeCase(str) {
  return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1_').toLowerCase()
}

module.exports = function(obj) {
  if (!obj) return obj

  if (typeof obj === 'string') return snakeCase(obj)

  return Object.keys(obj).reduce((hash, key) => {
    hash[snakeCase(key)] = obj[key]
    return hash
  }, {})
}
